/**
 * PIS i18next Configuration
 *
 * Initializes react-i18next via @rtvloco/platform/i18n with:
 *   - HttpBackend (loads JSON locale files from /locales/{lng}/{ns}.json)
 *   - LanguageDetector (localStorage > navigator)
 *   - Three supported locales: en (default), de, es
 *   - PIS-specific namespaces for each functional domain
 *
 * Locale files live at public/locales/{locale}/{namespace}.json
 */

import { initI18n } from '@rtvloco/platform/i18n';
import { STORAGE_KEY_LOCALE } from '../config/constants';

export const SUPPORTED_LOCALES = [
  { code: 'en', label: 'English', nativeLabel: 'English' },
  { code: 'de', label: 'German', nativeLabel: 'Deutsch' },
  { code: 'es', label: 'Spanish', nativeLabel: 'Espanol' },
] as const;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]['code'];

export const ALL_NAMESPACES = [
  'common',
  'nav',
  'auth',
  'textTask',
  'incident',
  'display',
  'device',
  'stop',
  'line',
  'group',
  'audio',
  'departure',
  'template',
  'monitoring',
  'notification',
  'system',
  'validation',
] as const;

export type I18nNamespace = (typeof ALL_NAMESPACES)[number];

// Clear any stored locale that is no longer supported
const storedLocale = localStorage.getItem(STORAGE_KEY_LOCALE);
if (
  storedLocale &&
  !SUPPORTED_LOCALES.map((l) => l.code).includes(storedLocale as SupportedLocale)
) {
  localStorage.removeItem(STORAGE_KEY_LOCALE);
}

initI18n({
  locales: ['en', 'de', 'es'],
  defaultLocale: 'en',
  backend: 'http',
  translationsPath: '/locales/{{lng}}/{{ns}}.json',
  namespaces: ALL_NAMESPACES as unknown as string[],
  storageKey: STORAGE_KEY_LOCALE,
});
